export default {
    login: {
        username: "Username",
        password: "Password",
        button: "Sign in",
        error: "Could not sign in, check your details",
        page_title: "Kevi, your opinion is worth rewards",
        intro_title: "We value your opinion!",
        intro_body: "Fill out the form and get a bonus.",
        coupons_title: "Track your coupons!",
        coupons_body: "Sign in to see the discounts you already earned.",
        invalid_link: "Invalid link.",
        used_link: "Link already used",
    },
    form: {
        save_error: "We could not send your answers. Please try again.",
        save_error_table: "Please check the table: some cells were not accepted.",
        page_title: "Kevi, your opinion is very important!",
        submit: "Submit",
        not_found: "Form not found.",
        already_answered:
            "You already answered this survey on <strong>{date}</strong>. You can answer again <strong>{next}</strong>",
        unused_coupon:
            "You still have an unused discount coupon. You can answer again after using your current coupon.",
        thanks_title: "Thank you!",
        thanks_message: "Your opinion is very important!",
        coupon_prize:
            "{name}, you just won <strong>{prize}</strong> on your next purchase!",
        coupon_valid_until: "Coupon valid until {date}",
        developed_with: "Made with",
    },
    user: {
        heading_known: "We would like to know a little more about you",
        heading: "Complete your details to finish",
        name: "First name",
        name_placeholder: "Enter your first name",
        name_error: "Please enter your first name",
        last_name: "Last name",
        last_name_placeholder: "Enter your last name",
        last_name_error: "Please enter your last name",
        email: "Email",
        email_placeholder: "Enter your email",
        email_error: "Please enter a valid email",
        phone: "Phone",
        phone_search: "Search...",
        phone_no_results: "No results found",
        phone_required: "Please enter your phone number",
        phone_invalid: "Please enter a valid phone number",
        birthdate: "Date of birth",
        birthdate_placeholder: "xx/xx/xxxx",
        birthdate_error: "Please check your date of birth",
    },
    question: {
        yes: "Yes",
        no: "No",
        select_option: "Select an option",
        select_options: "Select one or more options",
        select_at_least_one: "Select at least one option.",
        nps_low: "Would not recommend",
        nps_high: "Would recommend",
        ces_hard: "Extremely difficult",
        ces_easy: "Extremely easy",
        file_drop: "Click or drag your files here",
        file_uploading: "Uploading files...",
        file_hint: "{types} — up to {size} MB (max. {max})",
        file_types_any: "Files allowed by Kevi",
        file_types_image: "Images",
        file_types_image_dst: "Images or .DST embroidery",
        file_types_dst: ".DST embroidery",
        file_invalid_type: "{name}: file type not accepted",
        file_too_large: "{name}: exceeds {size} MB",
        file_too_many: "You can upload a maximum of {max} file(s).",
        file_upload_error: "Could not upload the files. Please try again.",
        table_row: "Row {n}",
        table_add_row: "Add row",
        table_duplicate: "Duplicate row",
        table_remove: "Remove row",
        table_min_rows: "Fill in at least {n} row(s).",
        table_max_rows: "At most {n} rows.",
        table_invalid_cells: "Check {n} cell(s), starting with {where}.",
        table_formula_error: "This cell could not be calculated",
        table_paste_skipped: "{n} row(s) did not fit in the table.",
    },
};
